import useTranslation from 'next-translate/useTranslation';
import { Button, Flex, Text } from '@eqi-investimentos/react';
import { useDeleteAccount } from '@/modules/Customer/http/client/mutations/useDeleteAccount';
import { Drawer } from '@/components/molecules/Drawer';
export const ConfirmDeleteAccountDrawer = () => {
  const {
    t
  } = useTranslation('common');
  const {
    mutate
  } = useDeleteAccount();
  return <Drawer id={CONFIRM_DELETE_ACCOUNT_ID} headerContent={<Text> {t('drawers.confirmDeleteAccount.header')}</Text>} data-sentry-element="Drawer" data-sentry-component="ConfirmDeleteAccountDrawer" data-sentry-source-file="ConfirmDeleteAccountDrawer.tsx">
      <Flex flexDir="column" h="full" justify="space-between" pb="9" data-sentry-element="Flex" data-sentry-source-file="ConfirmDeleteAccountDrawer.tsx">
        <Flex flexDir="column" gap="1.875rem" data-sentry-element="Flex" data-sentry-source-file="ConfirmDeleteAccountDrawer.tsx">
          <Text color="var(--color-eqi-black)" fontSize="lg" fontWeight="semibold" lineHeight="7" data-sentry-element="Text" data-sentry-source-file="ConfirmDeleteAccountDrawer.tsx">
            {t('drawers.confirmDeleteAccount.title')}
          </Text>
          <Text color="var(--color-eqi-black)" fontWeight="light" lineHeight="xl" data-sentry-element="Text" data-sentry-source-file="ConfirmDeleteAccountDrawer.tsx">
            {t('drawers.confirmDeleteAccount.description')}
          </Text>
        </Flex>
        <Flex flexDir="column" gap="5" data-sentry-element="Flex" data-sentry-source-file="ConfirmDeleteAccountDrawer.tsx">
          <Button justifyContent="center" onClick={() => window.dispatchEvent(new CustomEvent(`close-chakra-modal-${CONFIRM_DELETE_ACCOUNT_ID}`))} data-sentry-element="Button" data-sentry-source-file="ConfirmDeleteAccountDrawer.tsx">
            {t('attributes.cancel')}
          </Button>
          <Button justifyContent="center" variant="outline" onClick={() => mutate()} data-sentry-element="Button" data-sentry-source-file="ConfirmDeleteAccountDrawer.tsx">
            {t('drawers.confirmDeleteAccount.confirmButton')}
          </Button>
        </Flex>
      </Flex>
    </Drawer>;
};
export const CONFIRM_DELETE_ACCOUNT_ID = 'confirm-delete-account';